export default class BookingSummaryManager {
    constructor() {
        if (!document.querySelector('[data-entity="booking-summary"]') ||
            !document.querySelector('[data-entity="booking-summary-overview"]')) {
            return;
        }

        document.querySelector('[data-entity="booking-summary-overview"]').addEventListener("click", (event) => {
            const bookingSummaryModule = document.querySelector('[data-entity="booking-summary"]');
            bookingSummaryModule.classList.add('open');
            document.body.classList.add('booking-summary-open');
        });

        document.querySelector('[data-action="booking-summary-hide"]').addEventListener("click", (event) => {
            const bookingSummaryModule = document.querySelector('[data-entity="booking-summary"]');
            bookingSummaryModule.classList.remove('open');
            document.body.classList.remove('booking-summary-open');
        });

        window.addEventListener('scroll', (event) => {
            const affixContainer = document.querySelector('[data-entity="booking-summary-overview-wrapper"]');
            if (affixContainer) {
                const bookingSummaryModule = document.querySelector('[data-entity="booking-summary-overview"]');
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
                const offsetBottom = parseInt(affixContainer.getBoundingClientRect().top) +
                    parseInt(getComputedStyle(affixContainer, null).height.replace("px", ""));
                if (scrollTop > offsetBottom) {
                    bookingSummaryModule.classList.add('booking-summary-overview-fixed');
                } else {
                    bookingSummaryModule.classList.remove('booking-summary-overview-fixed');
                }
            }
        });
    }
}
